<template>
  <div class="nko-detail">
    <div class="nko-header-wrapper">
      <div class="container">
        <NkoDetailHeader/>
      </div>
    </div>
    <div class="container">
      <main class="nko-detail-main">
        <div class="nko-detail-main__block">
          <div v-if="screenWidth <= 1024">
            <breadcrumbs :items="subHeader.breadcrumbs"/>
            <h1 class="nko-detail-main__title">
              {{ subHeader.title }}
            </h1>
          </div>
          <NkoDetailContent />
          <NkoDetailProjects />
          <Reviews />
          <ReviewsModal />
        </div>
        <aside class="nko-detail-main__aside">
          <NkoDetailMenu/>
        </aside>
      </main>
    </div>
  </div>
</template>

<script>
import {useHeader} from "../../composables/useHeader";
import Breadcrumbs from "../main/Breadcrumbs";

export default {
  name: 'NkoDetail',
  props: ['result'],
  components: {
    Breadcrumbs,
  },
  setup: (props, ctx) => {
    const {subHeader} = useHeader();
    return {
      subHeader
    }
  },

}
</script>

<style lang="scss" scoped>
.nko-detail {

}

.nko-header-wrapper {
  background-color: #fff;
  padding-top: calc(rem(100) + rem(50));
  padding-bottom: rem(60);

  @include tablet {
    padding-top: calc(rem(80) + rem(38));
  }
  @include mobile {
    padding-top: calc(rem(55) + rem(26));
    padding-bottom: rem(16);
  }
}

.nko-detail-main {
  display: grid;
  grid-template-columns: 1fr .48fr;
  grid-column-gap: 73px;
  @include tablet {
    grid-template-columns: 1fr;
  }

  &__block {
    padding-top: 74px;
    @include tablet {
      padding-top: 25px;
      order: 2;
    }
    @include mobile{
      padding-top: 37px;
    }
  }

  &__aside {
    @include tablet {
      padding-top: 37px;
    }
    @include mobile {
      padding-top: 15px;
    }

    :deep {
      .a-select {
        &:after {
          content: '';
          display: block;
          width: 12px;
          height: 10px;
          background-size: 100%;
          background-image: url("/local/templates/main/img/nko/arrow.png");
        }
      }

      .a-select-icon {
        display: none;
      }
      .field{
        margin-top: 0;
      }
    }
  }

  &__title{
    font-size: 22px;
    line-height: 28px;
    color: #000000;
    @include tablet{
      margin: 0 0 38px;
    }
    @include mobile{
      margin: 0 0 22px;
    }
  }
  :deep{
    .breadcrumbs{
      margin-bottom: 14px;
    }
  }
}
</style>